import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import { IShipmentsPerDay } from "./ShipmentsPerDay.types";

export default class ShipmentsPerDay {
    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/ShipmentsPerDay`, {params: rawQuery});
            return res.data as IWidgetResponse<IShipmentsPerDay>;
        } catch (e: any) {
            console.error('Could not get ShipmentsPerDay data: ', e.message);
            return undefined;
        }
    }
}